module.exports = __webpack_public_path__ + "media/reskin-images/icon--email-confirmation-6a8835b9.svg";